(function() {
    'use strict';

    angular.module('holiday', [
            'ui.router',
            'holiday.constants',
            'holiday.services',
            'ui.calendar',
            'ui.bootstrap'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'holidayPermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, holidayPermissionsConst) {
        $stateProvider
            .state('layout.holiday', {
                abstract: true,
                url: '/holidays',
                data: {
                    title: 'Dni wolne',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.holiday.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/holiday/views/holiday-list/holiday-list.html',
                        controller: 'HolidayListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: holidayPermissionsConst.view
                }
            });
    }
})();
